import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Avatar from '@mui/material/Avatar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AppContext } from '../../contexts/AppContext';
import bookPhoto from '../../images/plan-a-media-group-book-intro-session.gif';
import '../../App.css';

export default function Services() {
  const { useMobileView } = useContext(AppContext);

  const filmTestingText = (
    <Typography>
      Your film (or pilot, web series, etc.) isn't quite working, but you don't know why...or you are wanting unbiased confirmation of what 
      <i> is</i> working. Let me help. I understand what you are trying to say and if it is landing. I’m known for 
      useful notes that highlight blindspots, clarify what is confusing and streamline your story. I provide 
      realistic suggestions and usable solutions producers and directors utilize to solve film issues. Show 
      me your edit before signing off, before submitting, before panicking.
    </Typography>
  );

  const scriptAnalysisText1 = (
    <Typography>
      I’ve read over 15,000 scripts - I’ve seen the good, the bad and everything in between. 
      Writers: I have a love of words, a respect for your vision and a desire to see your 
      idea make it onto the page. Need a new perspective, a fresh set of eyes, a trusted 
      viewpoint, a temperature check of what is working before submitting? Let’s do it!
    </Typography>
  );

  const scriptAnalysisText2 = (
    <Typography>
      Producers and directors: want an unbiased last look at your script before you start 
      filming? Do you really need that scene? Is something still missing in the story? 
      Let’s save you frustration in post by giving it one last look before your shoot.
    </Typography>
  );

  const pitchReviewsText = (
    <Typography>
      Show me what you’re working with. You have one shot when you present to the studio, 
      the producers, the investors...let’s get it right.
    </Typography>
  );

  const creativeConsultingText = (
    <Typography>
      We all hit walls - with a project, with a team, with an idea...<b>Plan <span style={{ color: 'red' }}>A</span></b> Media group is a great space to 
      look at things differently, explore new answers, cultivate communication and create a plan of action.
    </Typography>
  );

  const careerCoachingText = (
    <Typography>
      You’re awesome...but it turns out also scattered, scared, self-sabotaging or a 
      gifted procrastinator. Let’s make a plan to fix that.
    </Typography>
  );

  const virtualRetreatText = (
    <Typography>
      Need to fast track a project?  What can we accomplish in 48 or 72 hours together? Exactly 
      what you need. Offering one-on-one or small group creative retreats for accelerated project 
      completion. Retreats can also be created with multiple <b>Plan <span style={{ color: 'red' }}>A </span></b> assets involved (professional 
      writers, directors, editors etc) for further guidance. Inquire for more detail and to request 
      a curated experience catered to your exact needs.
    </Typography>
  );

  /* const stagedReadingText = (
    <Typography>
      Need to hear your work read out loud by professional actors?  <b>Plan <span style={{ color: 'red' }}>A </span></b> 
      has access to a wide range of actors to hear your work 'on its feet.' Inquire for more information.
    </Typography>
  ); */

  const studioAText = (
    <Typography>
      Want immediate help? <Link to="/studioA">Visit <b>Studio <span style={{ color: 'red' }}>A</span></b></Link>
      {' '}
      for immediate access to exclusive materials to support your creative process.
    </Typography>
  );

  const planALiveText = (
    <Typography>
      Bring Adrienne and <b>Plan <span style={{ color: 'red' }}>A </span></b> Media Group to your virtual or live event, 
      fan convention, industry panel, University / student experience or corporate retreat.
    </Typography>
  );

  const contactText = (
    <>
      <Typography align="center">
        Thank you for your interest in working with Adrienne / <b>Plan <span style={{ color: 'red' }}>A</span></b> Media Group.
      </Typography>
      <Typography align="center">
        Current clients and other inquiries may <a href="#contact">contact me</a> using the form below.
      </Typography>
      <Typography align="center">
        No unsolicited materials accepted.
      </Typography>
      <br />
      <Typography align="center">
        Note: The first step for all new clients is to book a 2-hour intro session. Must be used within 90 days. Book yours here:
      </Typography>
      <br />
      <Grid item xs={12} container justifyContent="center">
        {!useMobileView ? (
            <Avatar
              variant={"rounded"}
              src={bookPhoto}
              alt="Book a 2 hour consult with Adrienne"
              sx={{ width: '50%', height: '100%', cursor: 'pointer' }}
              onClick={() => window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=5N3BQH9D4UNWU', '_blank')}
            />
          ) : (
            <img
              src={bookPhoto}
              alt="Book a 2 hour consult with Adrienne"
              width='300px'
              height='300px'
              onClick={() => window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=5N3BQH9D4UNWU', '_blank')}
            />
          )}
      </Grid>
    </>
  );

  const mobileView = (
    <>
      <div>
        <div style={{ paddingBottom: '16px '}}>
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
            Services Include:
          </Typography>
        </div>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span>Film Testing / Edit Review
              <br />
              (Assembly / Rough Cut Feedback / Quality Control)
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {filmTestingText}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Script Analysis / Feedback
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              {scriptAnalysisText1}
            </div>
            <div style={{ paddingTop: '16px' }}>
              {scriptAnalysisText2}
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Pitch Reviews / Materials Reviews / Proofing
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {pitchReviewsText}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Creative Consulting / Problem Solving
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {creativeConsultingText}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel5a-content"
            id="panel5a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Career Coaching / Accountability Partnership
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {careerCoachingText}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel6a-content"
            id="panel6a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Virtual & In-Person Creative Retreats
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {virtualRetreatText}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel7a-content"
            id="panel7a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Studio <span style={{ color: 'red' }}>A</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {studioAText}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            backgroundColor: 'black',
            color: 'white',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel7a-content"
            id="panel7a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Plan <span style={{ color: 'red' }}>A</span> Live!
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {planALiveText}
          </AccordionDetails>
        </Accordion>
      </div>
      <div style={{ paddingTop: '24px', textAlign: 'center' }}>
        {contactText}
      </div>
    </>
  );

  const desktopView = (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Services Include:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span>Film Testing / Edit Review
          <br />
          (Assembly / Rough Cut Feedback / Quality Control)
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {filmTestingText}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Script Analysis / Feedback
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {scriptAnalysisText1}
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {scriptAnalysisText2}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Pitch Reviews / Materials Reviews / Proofing
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {pitchReviewsText}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Creative Consulting / Problem Solving
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {creativeConsultingText}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Career Coaching / Accountability Partnership
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {careerCoachingText}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Virtual & In-Person Creative Retreats
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {virtualRetreatText}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Studio <span style={{ color: 'red' }}>A</span>
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {studioAText}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'red', fontWeight: 900 }}>&#8212; </span> Plan <span style={{ color: 'red' }}>A</span> Live!
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        {planALiveText}
      </Grid>
      <Grid item xs={12} sx={{ paddingTop: '48px !important' }}>
        {contactText}
      </Grid>
    </Grid>
  );

  return (
    <Box
      sx={{
        border: '2px solid white',
        borderRadius: '4px',
        padding: '24px',
        borderBottom: useMobileView ? 'none' : '2px solid white'
      }}
    >
      {useMobileView ? mobileView : desktopView}
    </Box>
  );
}